module.exports = __webpack_public_path__ + "logo-with-title-white.svg";